import ggtImage from '../assets/ggt.png';

export const speakingEngagements = [
  {
    id: 1,
    title: "Career in STEM",
    organizer: "Girls Go Tech, The Women's Foundation",
    date: "Aug 24, 2022",
    topic: "Programming Games, Programming a Future Career",
    description: "The session covered industry insights, personal experience, and future opportunities, with a focus on empowering young women to break into tech.",
    keyPoints: [
        'Shared personal journey as a local game developer, showcasing projects and coding experience',
        'Introduced game development trends including the rise of the Metaverse and NFTs in education and business',
        'Offered practical advice on building academic paths and launching a career in the gaming industry',
        'Featured global perspectives, including an interview from Cisco Networking Academy with a female game developer in the U.S.'
    ],
    isUpcoming: false,
    image: ggtImage,
    linkedinPost: "https://www.linkedin.com/embed/feed/update/urn:li:share:6973466380956315648",
    location: "Hong Kong"
  }
];